import type {
  MessageFromServiceWorker,
  MessageToServiceWorker,
} from "@src/types";
import { v4 as uuidv4 } from "uuid";

import { alwaysResolve } from "@src/utils/alwaysResolve";
import { getServiceWorker } from "@src/utils/serviceWorker/getServiceWorker";

export async function exchangeMessage(
  messageToServiceWorker: MessageToServiceWorker,
) {
  const { success, result } = await alwaysResolve(getServiceWorker());
  if (!success) {
    console.error(
      "Service Worker not available to exchangeMessage:",
      messageToServiceWorker,
    );
    return Promise.reject(result);
  }

  return new Promise<MessageFromServiceWorker>((resolve) => {
    if ("messageId" in messageToServiceWorker) {
      // resposta disponível externamente
    } else {
      // resposta disponível apenas ao remetente
      messageToServiceWorker.messageId =
        messageToServiceWorker.idRadio + "_" + uuidv4();
    }
    result.postMessage(messageToServiceWorker);

    const onMessage = function _onMessage(event: MessageEvent) {
      const eventData: MessageFromServiceWorker = event.data;
      if (eventData.originMessageId === messageToServiceWorker.messageId) {
        navigator.serviceWorker.removeEventListener("message", onMessage);
        resolve(eventData);
      }
    };
    navigator.serviceWorker.addEventListener("message", onMessage);
  });
}
